import { reaction, runInAction } from "mobx";
import RouterStore from "../store/RouterStore";
import EscaninhoService from "../services/EscaninhoService";
import EscaninhoStore from "../store/EscaninhoStore";
import { AppStore } from "../store/AppStore";
import ReactionsProcessoExpandido from "./ReactionsProcessoExpandido";
import ProcessoStore from "../store/ProcessoStore";
import ImportacaoService from "../services/ImportacaoService";
import FiltroStore from "../store/FiltroStore";

class ReactionsEscaninho {
    private versaoPreparacao = 0;

    iniciarReactions = () => {
        reaction(() => EscaninhoStore.tipoEscaninho, () => {
            this.ajustesAoCarregarEscaninho();
        });
        ReactionsProcessoExpandido.iniciarReaction();
    }

    ajustesAoCarregarEscaninho = async () => {
        const versao = ++this.versaoPreparacao;
        FiltroStore.cancelarAplicacaoFiltro();
        runInAction(() => {
            FiltroStore.preparandoEscaninho = RouterStore.isAlgumEscaninho && !RouterStore.isEscaninhoPauta;
            FiltroStore.carregandoEntradaEscaninho = FiltroStore.preparandoEscaninho;
        });
        if (!RouterStore.isAlgumEscaninho) return;

        if (!RouterStore.isEscaninhoPauta) {
            await new Promise<void>(resolve => {
                requestAnimationFrame(() => requestAnimationFrame(() => resolve()));
            });
        }
        const cancelado = () => versao !== this.versaoPreparacao || !RouterStore.isAlgumEscaninho;
        while (!cancelado() && (AppStore.isCarregandoTodosProcessos || !ProcessoStore.carregouProcessosNoEscaninho)) {
            await new Promise<void>(resolve => setTimeout(resolve, 100));
        }
        if (cancelado()) return;

        runInAction(() => {
            FiltroStore.preparandoEscaninho = false;
            // No gabinete, a preparação em blocos já limpa a seleção de cada processo.
            if (!RouterStore.isEscaninhoGerencial) EscaninhoService.deselecionarProcessos();
            EscaninhoService.ajustarFiltros(true, true);
            if (!FiltroStore.carregandoAplicacaoFiltro) {
                FiltroStore.carregandoEntradaEscaninho = false;
            }
        });
        if (RouterStore.isImportacaoNoEscaninho) {
            ImportacaoService.iniciaEventoImportacao(RouterStore.getParam('codImportacao')[0]);
        }
    }
}

export default new ReactionsEscaninho();
